import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCombobox,{class:{'required': _vm.required},attrs:{"value":_vm.quantity,"label":_vm.label,"autocomplete":"off","items":_vm.items,"return-object":"","hide-no-data":"","hide-selected":"","rules":_vm.rules || _vm.defaultRules},on:{"change":_vm.updateQuantity}})
}
var staticRenderFns = []

export { render, staticRenderFns }